import api from "./apiConfig";

export const CREATE_CONTRACTUAL_DOCS = async (data) => {
	try {
		const response = await api.post("/contractualDocuments", data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const GET_CONTRACTUAL_DOCS_BY_CASO = async (id) => {
	try {
		const response = await api.get(`/contractualDocumentsByTaxMatterId/${id}`);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};

export const UPDATE_CONTRACTUAL_DOCS = async (id, data) => {
	try {
		const response = await api.put(`/contractualDocuments/${id}`, data);
		return response.data;
	} catch (error) {
		console.error("Error en el registro:", error);
		throw error;
	}
};